import { render, staticRenderFns } from "./CoozzySlidersHIcon.vue?vue&type=template&id=49851b80&scoped=true"
import script from "./CoozzySlidersHIcon.vue?vue&type=script&lang=js"
export * from "./CoozzySlidersHIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzySlidersHIcon.vue?vue&type=style&index=0&id=49851b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49851b80",
  null
  
)

export default component.exports